import React, { useEffect, useState } from 'react'
import { BRAND_NAME } from '../../theme/brand';
import Header from '../../components/Header'
import { Flex, Tab, TabList, TabPanel, TabPanels, Tabs, Box, Divider, Text, Center, Spinner, Link as ChakraLink } from '@chakra-ui/react';
import Kotlin from './Kotlin/Kotlin'

import { LuCode2, LuSmartphone, LuArrowLeft } from 'react-icons/lu'

import { fetchWrapper } from '../../helpers'
import ReactNativeSDK from './ReactNative/ReactNative'
import SwiftSDKIntegration from './Swift/Swift'
import FlutterSDK from './Flutter/Flutter'
import { useSearchParams, Link } from 'react-router-dom';
import {  } from '@chakra-ui/icons';
import { getApiHeaders, hasPermission } from '../../utils/DefaultFunction'
import API from '../../helpers/axiosInstance'
import BoxWrapper from '../../components/BoxWrapper/BoxWrapper'

// Original hardcoded SDK docs page. Stays live at /documentation/configure-sdk (the
// default) while the dynamic API-driven version is opt-in at
// /documentation/configure-sdk-new. Swap the routes in App.js once the new version
// covers everything this one does, and this file can go away.
const ConfiguresdkLegacy = ({ header }) => {
  const [data, setData] = useState('')
  const [searchParams, setSearchParams] = useSearchParams()



  const sdkTabs = ['kotlin', 'swift', 'react-native', 'flutter']


  const getInitialTabIndex = () => {
    const sdk = searchParams.get('sdk')
    const index = sdkTabs.indexOf(sdk)
    return index !== -1 ? index : 0
  }

  const [tabIndex, setTabIndex] = useState(getInitialTabIndex())
  const [loading, setLoading] = useState(false);

  const [permissions, setPermissions] = useState([]);




  const fetchPermissions = async () => {
    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_API_URL}/permission/feature/list?slug=documentation/configure-sdk`;
      const response = await API.get(url, { headers: getApiHeaders() });

      setPermissions(response.data.data || []);
    } catch (error) {
      console.error("Error fetching permissions:", error);
      setPermissions([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchPermissions();
  }, []);


  const viewPermission = hasPermission("configure-sdk", permissions)
  useEffect(() => {
    loadKey();
  }, []);

  useEffect(() => {

    const sdk = searchParams.get('sdk')
    const index = sdkTabs.indexOf(sdk)
    if (index !== -1 && index !== tabIndex) {
      setTabIndex(index)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams])

  const loadKey = async () => {
    let user = JSON.parse(localStorage.getItem('customer'))

    const url = `${process.env.REACT_APP_API_URL}/customer/get-sdk-key`;
    const data = await fetchWrapper.get(url)

    setData(data)
  }

  const handleTabChange = (index) => {
    setTabIndex(index)
    setSearchParams({ sdk: sdkTabs[index] })
  }

  if (loading) {
    return (
      <>
        <Header />
        <BoxWrapper>
          <Center h="400px">
            <Spinner size="xl" color="blue.500" thickness="4px" />
          </Center>
        </BoxWrapper>
      </>
    );
  }
  return (
    <>
      <Header header={header} />
      <BoxWrapper>
        {viewPermission ? <><Flex justify={"center"} align={"center"}>
          <Box w={"70%"} mt={8}>
            <ChakraLink as={Link} to="/documentation/configure-sdk-new" display="inline-flex" alignItems="center" fontSize="sm" color="var(--brand-primary)" mb={3}>
              Try the new SDK Integration page <LuArrowLeft style={{ marginLeft: ".4rem", transform: "rotate(180deg)" }} />
            </ChakraLink>
            <Text fontSize={"4xl"} fontWeight={"semibold"}>
              <Flex align={"center"}><LuSmartphone style={{ marginRight: ".5rem", color: "var(--brand-primary)" }} /> SDK Integration</Flex>
            </Text>
            <Text fontSize="sm" >SDK Integration
              Integrate the {BRAND_NAME} SDK into your mobile applications with native support for Android, iOS, React Native, and Flutter
            </Text>
          </Box>
        </Flex>
          <Divider bg={"#eaeaea"} my={8} />
          <Flex justify={"center"} align="center">
            <Box w={"70%"}>
              <Tabs variant="enclosed" index={tabIndex} onChange={handleTabChange}>
                <TabList
                  bg="#f1f5f9"
                  p="1"
                  borderRadius="full"
                  display="flex"
                  justifyContent="space-between"
                >
                  <Tab flex="1" _selected={{ bg: "white", boxShadow: "sm", fontWeight: "600" }} borderRadius="full" fontSize="sm" ><LuCode2 style={{ marginRight: ".5rem" }} />Kotlin</Tab>
                  <Tab flex="1" _selected={{ bg: "white", boxShadow: "sm", fontWeight: "600" }} borderRadius="full" fontSize="sm" ><LuCode2 style={{ marginRight: ".5rem" }} />Swift</Tab>
                  <Tab flex="1" _selected={{ bg: "white", boxShadow: "sm", fontWeight: "600" }} borderRadius="full" fontSize="sm" ><LuCode2 style={{ marginRight: ".5rem" }} />React Native</Tab>
                  <Tab flex="1" _selected={{ bg: "white", boxShadow: "sm", fontWeight: "600" }} borderRadius="full" fontSize="sm" ><LuCode2 style={{ marginRight: ".5rem" }} />Flutter</Tab>
                </TabList>

                <TabPanels>
                  <TabPanel>
                    <Kotlin data={data} />
                  </TabPanel>

                  <TabPanel>
                    <SwiftSDKIntegration data={data} />
                  </TabPanel>
                  <TabPanel>
                    <ReactNativeSDK data={data} />
                  </TabPanel>
                  <TabPanel>
                    <FlutterSDK data={data} />
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </Box>
          </Flex></> : <Box className='card-style'>
          <Center h="400px">
            <Box textAlign="center">
              <Text fontSize="xl" fontWeight="semibold" color="gray.700" mb={2}>
                No Access
              </Text>
              <Text fontSize="sm" color="gray.500">
                You don't have permission to view this sections.
              </Text>
            </Box>
          </Center>
        </Box>}

      </BoxWrapper>
    </>
  )
}

export default ConfiguresdkLegacy
